const mEditionBillingModifyUser = {
  mEditionBillingModifyUser: {
    alerts: {
      messageSuccess: 'El usuario fue actualizado correctamente. La nueva contraseña es ',
      messageError: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.'
    }
  }
}

export default mEditionBillingModifyUser
